import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, Optional } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TalkMeService } from '@main/online-chats/feature';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { filter, take } from 'rxjs/operators';
import { ChatMenuComponentService } from '../chat-menu/chat-menu-component.service';

@Component({
  selector: 'ui-talk-me',
  templateUrl: './talk-me.component.html',
  styleUrls: ['./talk-me.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TalkMeComponent implements OnInit {
  public iconType = CUSTOM_ICON_TYPE;

  destroyRef = inject(DestroyRef);

  constructor(
    public talkMeService: TalkMeService,
    @Optional() private chatMenuComponentService: ChatMenuComponentService,
  ) {}

  ngOnInit(): void {
    if (this.chatMenuComponentService) {
      this.chatMenuComponentService.isExpanded$
        .pipe(takeUntilDestroyed(this.destroyRef), filter(Boolean), take(1))
        .subscribe(() => {
          this.talkMeService.init();
        });
    } else {
      this.talkMeService.init();
    }
  }
}
